import "./App.css";
import LogProvider from "./components/LogProvider";
import CustomErrorBoundary from "./components/CustomErrorBoundary";
import ToolProvider from "./context/ToolContext";
import FormProvider from "./context/FormContext";
import { WarningModalProvider } from "./context/WarningModalContext";
import { store } from "./app/store";
import { Provider } from "react-redux";
import ClientSettings from "./components/ClientSettings";

const App = () => {
  return (
    <Provider store={store}>
      <CustomErrorBoundary>
        <WarningModalProvider>
          <ToolProvider>
            <FormProvider>
              <ClientSettings>
                <LogProvider />
              </ClientSettings>
            </FormProvider>
          </ToolProvider>
        </WarningModalProvider>
      </CustomErrorBoundary>
    </Provider>
  );
};

export default App;
